import { render, staticRenderFns } from "./ConsultantworkloadRelation.vue?vue&type=template&id=7bdaa2b4&scoped=true&"
import script from "./ConsultantworkloadRelation.vue?vue&type=script&lang=js&"
export * from "./ConsultantworkloadRelation.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantworkloadRelation.vue?vue&type=style&index=0&id=7bdaa2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdaa2b4",
  null
  
)

export default component.exports